import script from "./OpsSplashScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsSplashScreen.vue?vue&type=script&setup=true&lang=js"

import "./OpsSplashScreen.vue?vue&type=style&index=0&id=10e95406&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10e95406"]])

export default __exports__